<template>
  <el-select
    :style="customStyle"
    :disabled="seznamPrikljuckovGrupirano.length === 0"
    @change="$emit('novIzbranPrikljucek', izbranPrikljucekProp)"
    value-key="id_prikljucek"
    v-model="izbranPrikljucekProp"
    placeholder="Izberite priključek"
    :class="styleClass"
    filterable>
    <template v-for="grupa in seznamPrikljuckovGrupirano">
      <el-option-group
        v-if="grupa.prikljucki.length > 0"
        :key="grupa.label"
        :label="grupa.label">
        <el-option
          v-for="(data, key) in grupa.prikljucki"
          :value="data.id_prikljucek"
          :key="key"
          :label="grupa.prikljucki.length === 1 ?
            (data.tip_prikljucka === 'CLOUD STORITVE' ? data.id_prikljucek : data.podatekZaIzpisPrikljucek) :
            (data.tip_prikljucka === 'CLOUD STORITVE' ? data.id_prikljucek : data.podatekZaIzpisPrikljucek + ' - ID ' + data.id_prikljucek)">
        </el-option>
      </el-option-group>
    </template>
  </el-select>
</template>
<script>
import {Option, OptionGroup, Input} from 'element-ui'
export default {
  components: {
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
    [Input.name]: Input
  },
  props: {
    seznamPrikljuckovGrupirano: {
      type: Array,
      default: []
    },
    styleClass: {
      type: String,
      default: ''
    },
    izbranPrikljucek: {
      type: String,
      default: ''
    },
    customStyle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      izbranPrikljucekProp: ''
    }
  },
  mounted () {
    this.izbranPrikljucekProp = this.izbranPrikljucek
  },
  watch: {
    izbranPrikljucek: function () {
      this.izbranPrikljucekProp = this.izbranPrikljucek
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GlobalneKomponente/IzbirnikPrikljuckaSelect.vue